var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.187 18c.302 0 .539-.128.711-.384L17.821 8.2c.062-.098.107-.19.136-.276.029-.085.043-.166.043-.243 0-.202-.062-.366-.186-.492S17.528 7 17.329 7c-.142 0-.26.028-.353.084-.093.057-.186.154-.279.294l-5.53 8.936-2.864-3.757c-.164-.224-.366-.337-.605-.337-.204 0-.371.065-.502.196-.13.13-.196.296-.196.499 0 .085.017.173.05.263.033.09.087.18.163.27l3.25 4.168c.208.256.45.384.724.384z",
    transform: "translate(-255 -100) translate(248 93)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckWhite);
export default __webpack_public_path__ + "static/media/ic_check_white.b275a356e4bee4c330707592b0530af9.svg";
export { ForwardRef as ReactComponent };